import React from "react";
import axios from "axios";
axios.defaults.withCredentials = true;
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
